import { render } from "./TextAnalysisEnhancements.vue?vue&type=template&id=0ff6f232"
import script from "./TextAnalysisEnhancements.vue?vue&type=script&lang=js"
export * from "./TextAnalysisEnhancements.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__